import {
    useContext
} from "react";
import {
    BubbleContentToggleContext
} from "./context";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    ChevronDown as ChevronDownIcon,
    ChevronUp as ChevronUpIcon
} from "lucide-react-native";
import AnimatedIcon from "../../../animatedIcon";

export const BubbleContentToggleIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => {
    const {
        customTheme,
        isOpen
    } = useContext(BubbleContentToggleContext);

    return <AnimatedIcon
        fromIcon={ChevronDownIcon}
        customTheme={customTheme}
        customColor={customColor}
        isTransitioned={isOpen}
        toIcon={ChevronUpIcon}
        iconTransition="morph"
        color={color}
        size={size}
    />;
};
